'use strict';

import 'chart.js';
import 'angular-chart.js';

angular.module('bcmModule', ['chart.js']);